import styled, { css } from "styled-components";
import {
  LABELS,
  ScrollToTopOnMount,
  parseCSS,
  randomName,
  useRefresh,
} from "scripts/FunctionsBundle";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import * as _T from "@utils/ClassTypes";
import SearchTable from "@components/SearchTable";
import NichosForms from "@components/NichosForms";
import { GS } from "App";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// SeccionesScreen => Rename all instances to use
type SeccionesScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################
const _SeccionesScreen = (props: SeccionesScreenProps) => {
  // ------------------------------------------------------------------------------------ REFRESHERS
  const [refreshSections, volkeySections] = useRefresh();
  const [refreshNichos, volkeyNichos] = useRefresh();

  // ------------------------------------------------------------------------------------ LOCAL STATE
  const [LS, setLS] = useState({
    currSection: null as _T.Seccion | null,
    currNicho: null as _T.Nicho | null,
  });

  // useEffect(() => {

  //   // refreshNichos();
  // }, []);

  // if (!GS.servicios.secciones || !GS.servicios.nichos) {
  //   return <div className="spinner">Cargando...</div>;
  // }

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className + " screen"}>
      <Helmet>
        <title>Estructura de Nichos | RSA</title>
      </Helmet>
      <ScrollToTopOnMount />

      <h1>Administrador de Secciones</h1>
      <h2>Modificar información de secciones</h2>

      {/* ------------------------------------------------------------------------------------ SECCION TABLE */}
      <SearchTable
        key={volkeySections}
        _allowCollapse
        _allowOrder
        _allowSearch
        _headers={LABELS._SECCIONES}
        _collection={GS.servicios.secciones || []}
        _collection_title={"Secciones"}
        _onSelect={(el, id) => {
          if (el.id === id) return;
          setLS({ ...LS, currSection: el });
        }}
      />

      {/* ------------------------------------------------------------------------------------ SECCION CRUD */}
      <div className="crud-buttons">
        <button
          className="big primary"
          onClick={() => {
            GS.servicios.secciones!.push(
              new _T.Seccion({ id: randomName("id") })
            );
            console.log(GS.servicios);
            refreshSections();
          }}
        >
          Crear nueva sección
        </button>
        <button
          className="danger"
          disabled={!LS.currSection}
          onClick={() => {
            if (!LS.currSection) return;
            const selIndex = GS.servicios.secciones!.findIndex(
              (s) => s.id === LS.currSection?.id
            );

            if (selIndex !== -1) {
              GS.servicios.secciones!.splice(selIndex, 1);
              setLS({ ...LS, currSection: null });
            }
            refreshSections();
          }}
        >
          Eliminar sección actual
        </button>
      </div>

      {/* ------------------------------------------------------------------------------------ SECCION FIELDSET */}
      {LS.currSection && (
        <NichosForms
          _type="seccion"
          _onSave={(seccion) => {
            const selIndex = GS.servicios.secciones!.findIndex(
              (s) => s.id === seccion?.id
            );
            if (selIndex !== -1) GS.servicios.secciones![selIndex] = seccion;
            refreshSections();
          }}
          _store={LS.currSection}
        />
      )}

      {/* ------------------------------------------------------------------------------------ DISPLAY NICHOS */}
      <h2>Modificar Nichos</h2>

      {GS.servicios.secciones?.length ? (
        <>
          {/* ------------------------------------------------------------------------------------ NICHOS TABLE */}
          <SearchTable
            key={volkeyNichos}
            _allowCollapse
            _allowOrder
            _allowSearch
            _headers={LABELS._NICHOS}
            _collection={GS.servicios.nichos || []}
            _collection_title={"Nichos"}
            _onSelect={(el, id) => {
              if (el.id === id) return;
              setLS({ ...LS, currNicho: el });
            }}
          />

          {/* ------------------------------------------------------------------------------------ NICHOS CRUD */}
          <div className="crud-buttons">
            <button
              className="big primary"
              onClick={() => {
                GS.servicios.nichos!.push(
                  new _T.Nicho({ id: randomName("id") })
                );
                console.log(GS.servicios);
                refreshNichos();
              }}
            >
              Crear nuevo nicho
            </button>
            <button
              className="danger"
              disabled={!LS.currNicho}
              onClick={() => {
                if (!LS.currNicho) return;
                const selIndex = GS.servicios.nichos!.findIndex(
                  (s) => s.id === LS.currNicho?.id
                );
                if (selIndex !== -1) {
                  GS.servicios.nichos!.splice(selIndex, 1);
                  setLS({ ...LS, currNicho: null });
                }
                refreshNichos();
              }}
            >
              Eliminar nicho actual
            </button>
          </div>

          {/* ------------------------------------------------------------------------------------ NICHOS FIELDSET */}
          {LS.currNicho && (
            <NichosForms
              _onSave={(nicho) => {
                const selIndex = GS.servicios.nichos!.findIndex(
                  (s) => s.id === nicho?.id
                );
                if (selIndex !== -1) GS.servicios.nichos![selIndex] = nicho;
                refreshNichos();
              }}
              _store={LS.currNicho}
              _type="nicho"
            />
          )}
        </>
      ) : (
        <h3 style={{ textAlign: "center" }}>
          Es necesario que exista al menos una sección
        </h3>
      )}
    </div>
  );
};

// ################################ STYLES ################################
const SeccionesScreen = styled(_SeccionesScreen).attrs(
  (props: SeccionesScreenProps): SeccionesScreenProps => {
    if (!GS.servicios.secciones) GS.servicios.secciones = [];
    if (!GS.servicios.nichos) GS.servicios.nichos = [];
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default SeccionesScreen;
